import { api } from "../api/Middleware";
import { CHATS_URL, WABOTTY_URL } from "../api/Urls";
import { formatPhoneForAPI } from "../helpers/Helpers";

const ChatService = {
  getAccount: async (token) => {
    try {
      const response = await api.get(
        WABOTTY_URL + `get_accounts/?b_token=${token}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching account:", error);
      throw error;
    }
  },

  getChats: async (session, offset = 0, limit = 10) => {
    const params = { session, limit, offset };

    const response = await api.get(`${CHATS_URL}`, { params });
    return response.data;
  },

  getChatMessages: async (session, phone, offset = null, limit = 30) => {
    try {
      phone = phone.replace(/\D/g, "");
      
      const params = { session,phone, limit };
      if (offset) params.offset = offset;

      const response = await api.get(CHATS_URL + `${phone}/messages/`, {
        params,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching chat messages:", error);
      throw error;
    }
  },

  // RF03 – Envio de mensagem via REST (fallback)
  sendMessage: async (data) => {
    try {
      const response = await api.post(CHATS_URL + "messages/send/", data);
      return response.data;
    } catch (error) {
      console.error("Error sending message:", error);
      throw error;
    }
  },

  // Envio de mensagem de áudio
  sendAudioMessage: async (formData) => {
    try {
      const response = await api.post(CHATS_URL + "messages/send/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error sending audio message:", error);
      throw error;
    }
  },
};

export default ChatService;